import { render, staticRenderFns } from "./RoundRobinBracket.vue?vue&type=template&id=b4506552&scoped=true&"
import script from "./RoundRobinBracket.vue?vue&type=script&lang=js&"
export * from "./RoundRobinBracket.vue?vue&type=script&lang=js&"
import style0 from "./RoundRobinBracket.vue?vue&type=style&index=0&id=b4506552&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4506552",
  null
  
)

export default component.exports